<template>
    <div>
        <div class="main-content" id="panel">
            <header-component></header-component>
            <!-- Header -->
            <div class="header pb-5 bg-gradient-lighter">
                <div class="container">
                    <div class="header-body">
                        <div class="row py-5">
                            <!--nombre del curso-->
                            <div class="col text-center">
                                <h1>Panel de docente</h1>
                                <p>Bienvenido al Panel de docente de eThinking. Elige entre las siguientes opciones para comenzar:</p>
                            </div>
                            <!--termina nombre del curso-->        
                        </div>
                    </div>
                </div>
            </div>
            <!-- Page content -->
            <div class="container-fluid mt--6">
                <div class="card">
                    <!-- Card body -->
                    <div class="card-body">
                        <div class="row">
                            <!--Bloque-->
                            <div class="col-md-6">
                                <div class="card bg-gradient-gray-dark shadow-panel">
                                    <!-- Card body -->
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-3">
                                                <!-- Avatar -->
                                                <router-link to="/admin-groups">
                                                    <img src="assets/img/docente/grupos-01.svg">
                                                </router-link>
                                            </div>
                                            <div class="col">
                                                <h4 class="card-title text-white mb-0 ">Administrador de Grupos</h4><br>
                                                <h6 class="text-white"><i class="far fa-check-circle"></i> Crea y administra grupos</h6>
                                                <h6 class="text-white"><i class="far fa-check-circle"></i> Asigna actividades y rúbricas a las personas y grupos</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card bg-gradient-gray-dark shadow-panel">
                                    <!-- Card body -->
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-3">
                                                <!-- Avatar -->
                                                <router-link to="/reporte-avance">
                                                    <img src="assets/img/docente/reportes-01.svg">
                                                </router-link>
                                            </div>
                                            <div class="col">
                                                <h4 class="card-title text-white mb-0 ">Reportes</h4><br>
                                                <h6 class="text-white"><i class="far fa-check-circle"></i> Da seguimiento al progreso de los alumnos</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NavigationComponent from '@/components/NavigationComponent'
import HeaderComponent from '@/components/HeaderComponent'
import VueForm from "vue-form"
import options from "../validations/validations.js";
Vue.use(VueForm, options);
export default {
    name: 'HomeTeacher',
    components: {
        NavigationComponent, HeaderComponent
    },
    data() {
        return {
            usuario: {},
            hostname: '',
        }
    },
    methods: {
        
    },
    async mounted() {
        this.hostname = hostname
        if(!user) {
            await this.getUserApi()
            this.usuario = user
        } else {
            this.usuario = user
        }
    },
    beforeMount() {
        document.body.classList.remove('bg-mos1')
    },
    watch: {
        
    }
}
</script>